import { normalizeRoles, hasAnyRole } from '../../../lib/roleUtils';

// Access levels (higher = more access)
export const ACCESS_LEVELS = {
  base: 0,
  instructor: 10,
  institutionalAdmin: 20,
  admin: 30,
};

// Tab visibility configuration
export const TAB_VISIBILITY = [
  { key: 'general',          label: 'General',            minView: 0,  minEdit: 0  },
  { key: 'features',         label: 'Features',           minView: 0,  minEdit: 30 },
  { key: 'forms-compliance', label: 'Forms & Compliance', minView: 0,  minEdit: 30 },
  { key: 'evaluations',      label: 'Evaluations',        minView: 0,  minEdit: 0  },
  { key: 'scenario-access',  label: 'Scenario Access',    minView: 30, minEdit: 30 },
  { key: 'cohorts',          label: 'Cohorts',            minView: 0,  minEdit: 0  },
  { key: 'security',         label: 'Security',           minView: 30, minEdit: 30 },
];

/**
 * Determine the access level for the current session user.
 * Right now only Gadget-level "admin" can see this page at all,
 * so everyone who loads it is ACCESS_LEVELS.admin.
 * The granularity is groundwork for future institutional-admin / instructor roles.
 */
export function getUserAccessLevel(session) {
  if (!session?.user?.roles) return ACCESS_LEVELS.base;

  // "admin" at the Gadget level IS the system admin
  if (hasAnyRole(session.user.roles, ['admin', 'system-admin'])) {
    return ACCESS_LEVELS.admin;
  }

  // Future: check user.institutionRole for institutional-admin
  // if (session.user.institutionRole === 'institutional-admin') return ACCESS_LEVELS.institutionalAdmin;

  // Anyone who can see this page is at least base-level for now
  return ACCESS_LEVELS.base;
}

/**
 * Return only the tabs that the user has permission to view.
 */
export function getVisibleTabs(session) {
  const level = getUserAccessLevel(session);
  return TAB_VISIBILITY.filter(tab => level >= tab.minView);
}

/**
 * Check whether the user can edit a specific tab.
 */
export function canEditTab(session, tabKey) {
  const level = getUserAccessLevel(session);
  const tab = TAB_VISIBILITY.find(t => t.key === tabKey);
  if (!tab) return false;
  return level >= tab.minEdit;
}
